<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import Multiselect from 'vue-multiselect'
import { Helper, debounce } from '@/mixin/helper'
import Swal from 'sweetalert2'
import moment from 'moment'
import { required, requiredIf, email } from 'vuelidate/lib/validators'
import { DELETE_ADDRESS, GET_ADDRESS, GET_DETAIL_ADDRESS } from '@/services/api/master/address'

moment.locale('id')

export default {
  page: {
    title: 'Form Pelanggan',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  mixins: [Helper],
  components: {
    Layout,
    PageHeader,
    Multiselect,
  },
  apollo: {
    geofences: {
      query: GET_ADDRESS,
      manual: true,
      fetchPolicy: 'no-cache',
      variables: {
        filter: {
          isCustomer: true,
          pagination: {
            page: 1,
            show: 10,
          },
        },
      },
      result({ data, loading }) {
        if (!loading) {
          this.totalRows = data.geofences.geofences.pagination.total
          this.geofences = data.geofences.geofences
        }
      },
    },
  },
  data() {
    return {
      filterAddressSelected: [],
      selected: {
        contact: [],
        deliveryNote: [],
        category: [],
      },
      selectedModel: {
        contact: [],
        deliveryNote: [],
        category: [],
      },
      allSelected: {
        contact: false,
        deliveryNote: false,
        category: false,
      },
      indeterminate: {
        contact: true,
        deliveryNote: true,
        category: true,
      },
      selectAllAddress: false,
      sales: {
        sales: [
          { name: 'Dimas Fariz' },
          { name: 'Alfian Yudistira' },
          { name: 'Wilis Bagio' },
          { name: 'Adi Tjandra' },
          { name: 'Risman Satria' },
        ],
      },
      companyCategories: {
        companyCategories: [
          { text: this.$t('global.create') + ' ' + this.$t('master.form.customer.industryCat') },
          { text: 'Makanan' },
          { text: 'Furnitur' },
          { text: 'Kimia' },
          { text: 'Logistik' },
          { text: 'Farmasi' },
        ],
      },
      formCategory: [],
      payment: {
        payment: [
          { name: this.$t('global.create') + ' ' + this.$t('master.form.customer.top.title') },
          { name: 'Net 30' },
          { name: 'Net 60' },
          { name: 'Net 90' },
        ],
      },
      geofences: [],
      form: {
        customerName: null,
        email: null,
        sales: null,
        taxNo: null,
        category: null,
        paymentTerms: null,
        contact: [],
        deliveryNote: [],
      },
      formOld: [],
      instantCreate: {
        category: [],
        paymentTerms: [],
      },
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      show: [
        { key: 'category', label: 'Kategori Alamat' },
        { key: 'activity', label: 'Aktivitas Alamat' },
        { key: 'address', label: 'Alamat Lengkap' },
        { key: 'province', label: 'Provinsi' },
        { key: 'city', label: 'Kota' },
      ],
      show_model: null,
      listAddress: [
        {
          key: 'check',
          thClass: 'mc-table--30',
          sortable: false,
        },
        {
          key: 'fenceName',
          label: 'Nama Lokasi',
          thClass: 'mc-table--50',
          sortable: true,
        },
        {
          key: 'category',
          label: 'Kategori Alamat',
          thClass: 'mc-table--50',
          sortable: true,
        },
        {
          key: 'activity',
          label: 'Aktivitas Alamat',
          thClass: 'mc-table--50',
          sortable: true,
        },
        {
          key: 'address',
          label: 'Alamat Lengkap',
          thClass: 'mc-table--50',
          sortable: true,
        },
        {
          key: 'province',
          label: this.$t('master.list.address.province'),
          thClass: 'mc-table--50',
          sortable: true,
        },
        {
          key: 'city',
          label: this.$t('master.list.address.city'),
          thClass: 'mc-table--50',
          sortable: true,
        },
      ],
      deleteAddress: [],
    }
  },
  validations: {
    form: {
      customerName: { required },
      email: { required, email },
      sales: { required },
      category: { required },
      contact: {
        $each: {
          contactName: {
            required: requiredIf(function () {
              return this.form.contact !== undefined && this.form.contact.length > 0
            }),
          },
        },
      },
      deliveryNote: {
        $each: {
          text: {
            required: requiredIf(function () {
              return this.form.deliveryNote !== undefined && this.form.deliveryNote.length > 0
            }),
          },
        },
      },
      industryCategory: {
        $each: {
          text: {
            required: requiredIf(function () {
              return (
                this.instantCreate.category !== undefined && this.instantCreate.category.length > 0
              )
            }),
          },
        },
      },
    },
  },
  computed: {
    title() {
      return this.$route.params.id === undefined ? this.$t('master.form.customer.newCustomer') : this.$t('master.form.customer.updateCustomer')
    },
    items() {
      return [
        {
          text: 'Data Master',
        },
        {
          text: this.$t('menuitems.masterData.list.customer'),
        },
        {
          text: this.$route.params.id === undefined ? this.$t('master.form.customer.newCustomer') : this.$t('master.form.customer.updateCustomer'),
        },
      ]
    },
    visibleAddress() {
      if (this.show_model && this.show_model.length > 0) {
        var result = this.show_model.map((a) => a.key)
        return this.listAddress.filter(function (item) {
          return item.key == 'check' || item.key == 'fenceName' || result.includes(item.key)
        })
      } else {
        return this.listAddress
      }
    },
    listContact() {
      return [
        {
          key: 'check',
          thClass: 'mc-table--30',
          sortable: false,
        },
        {
          key: 'contactName',
          label: 'Nama',
          thClass: 'mc-table--50',
          sortable: true,
        },
        {
          key: 'phoneNo',
          label: 'Nomor Telepon',
          thClass: 'mc-table--50',
          sortable: true,
        },
        {
          key: 'position',
          label: 'Posisi',
          thClass: 'mc-table--50',
          sortable: true,
        },
        {
          key: 'email',
          label: 'Email',
          thClass: 'mc-table--50',
          sortable: true,
        },
      ]
    },
    listNote() {
      return [
        {
          key: 'check',
          thClass: 'mc-table--30',
          sortable: false,
        },
        {
          key: 'text',
          label: 'Catatan Pengiriman',
          sortable: true,
        },
      ]
    },
    listCategory() {
      return [
        {
          key: 'check',
          thClass: 'mc-table--30',
          sortable: false,
        },
        {
          key: 'text',
          label: 'Kategori Industri',
          sortable: true,
        },
      ]
    },
  },
  created() {
    for (let i = 0; i < this.form.contact.length; i++) {
      this.selectedModel.contact.push(false)
    }

    this.$watch('selected.contact', (newValue) => {
      if (newValue.length === 0) {
        this.indeterminate.contact = false
        this.allSelected.contact = false
      } else if (newValue.length == this.form.contact.length) {
        this.indeterminate.contact = false
        this.allSelected.contact = true
      } else {
        this.indeterminate.contact = true
        this.allSelected.contact = false
      }
    })

    this.$watch('selected.deliveryNote', (newValue) => {
      if (newValue.length === 0) {
        this.indeterminate.deliveryNote = false
        this.allSelected.deliveryNote = false
      } else if (newValue.length == this.form.deliveryNote.length) {
        this.indeterminate.deliveryNote = false
        this.allSelected.deliveryNote = true
      } else {
        this.indeterminate.deliveryNote = true
        this.allSelected.deliveryNote = false
      }
    })

    this.$watch('selected.category', (newValue) => {
      if (newValue.length === 0) {
        this.indeterminate.category = false
        this.allSelected.category = false
      } else if (newValue.length == this.instantCreate.category.length) {
        this.indeterminate.category = false
        this.allSelected.category = true
      } else {
        this.indeterminate.category = true
        this.allSelected.category = false
      }
    })
  },
  mounted() {
    this.$apollo.queries.geofences.refetch()
  },
  methods: {
    searchData: debounce(function () {
      this.onFiltered()
    }, 500),
    onFiltered() {
      // Trigger pagination to update the number of buttons/pages due to filtering
      if (this.filter.length > 0 && this.filter.length < 3) return
      this.currentPage = 1
      this.$apollo.queries.geofences.refetch({
        filter: {
          isCustomer: true,
          search: this.filter,
          pagination: {
            page: 1,
            show: this.perPage,
          },
        },
      })
    },
    initEditPage(item) {
      this.form = {
        customerName: item.customerName,
        email: item.email,
        sales: { name: item.sales },
        taxNo: item.taxNo,
        category: { text: item.category },
        paymentTerms: { name: item.paymentTerms },
      }

      let contact = item.contact || []
      let resContact = []
      contact.forEach(function (item) {
        resContact.push({
          ...item,
          type: 'data',
        })
      })
      this.form.contact = resContact

      let note = item.deliveryNote || []
      let resNote = []
      note.forEach(function (item) {
        resNote.push({
          ...item,
          type: 'data',
        })
      })
      this.form.deliveryNote = resNote
    },
    changePerPage(perPage) {
      this.perPage = perPage
      if (this.filter == null) {
        this.$apollo.queries.geofences.refetch({
          filter: {
            isCustomer: true,
            pagination: {
              page: 1,
              show: this.perPage,
            },
          },
        })
      } else {
        this.$apollo.queries.geofences.refetch({
          filter: {
            isCustomer: true,
            search: this.filter,
            pagination: {
              page: 1,
              show: this.perPage,
            },
          },
        })
      }
    },
    changePage(page) {
      this.currentPage = page
      if (this.filter == null) {
        this.$apollo.queries.geofences.refetch({
          filter: {
            isCustomer: true,
            pagination: {
              page: this.currentPage,
              show: this.perPage,
            },
          },
        })
      } else {
        this.$apollo.queries.geofences.refetch({
          filter: {
            isCustomer: true,
            search: this.filter,
            pagination: {
              page: this.currentPage,
              show: this.perPage,
            },
          },
        })
      }
    },
    async toggleAllAddress(event) {
      var checked = event.target.checked
      var address = await this.$apollo.query({
        query: GET_ADDRESS,
        fetchPolicy: 'no-cache',
        variables: {
          filter: {
            isCustomer: false,
            pagination: {
              page: 1,
              show: this.totalRows,
            },
          },
        },
      })
      this.filterAddressSelected = []
      if (checked) {
        this.filterAddressSelected = address.data.geofences.geofences.data.map(
          (item) => item.geofenceId
        )
      } else {
        this.filterAddressSelected = []
      }
    },
    toggleAll(checked, param) {
      this.selectedModel[param] = []
      this.selected[param] = []
      if (checked) {
        if (param == 'category') {
          for (let i = 0; i < this.instantCreate[param].length; i++) {
            this.selected[param].push(i)
            this.selectedModel[param].push(true)
          }
        }
        for (let i = 0; i < this.form[param].length; i++) {
          this.selected[param].push(i)
          this.selectedModel[param].push(true)
        }
      } else {
        if (param == 'category') {
          for (let i = 0; i < this.instantCreate[param].length; i++) {
            this.selectedModel[param].push(false)
          }
        }
        for (let i = 0; i < this.form[param].length; i++) {
          this.selectedModel[param].push(false)
        }
        this.selected[param] = []
      }
    },
    checkAddress(event) {
      if (event.target.checked) {
        this.filterAddressSelected.push(parseInt(event.target.value))
        if (this.filterAddressSelected.length == this.totalRows) {
          this.selectAllAddress = true
        }
      } else {
        this.selectAllAddress = false
        var index = this.filterAddressSelected.indexOf(parseInt(event.target.value))
        if (index !== -1) {
          this.filterAddressSelected.splice(index, 1)
        }
      }
    },
    checkTable(event, data, param) {
      if (event) {
        this.selected[param].push(data.index)
      } else {
        var myIndex = this.selected[param].indexOf(data.index)
        if (myIndex !== -1) {
          this.selected[param].splice(myIndex, 1)
        }
      }
    },
    add(param, obj) {
      this.form[param].push(obj)
    },
    toDelete(param) {
      this.selected[param].sort()
      this.selected[param].reverse()
      if (param == 'category') {
        this.selected[param].forEach((row) => {
          this.$delete(this.instantCreate[param], row)
        })
        for (let i = 0; i < this.instantCreate[param].length; i++) {
          this.selectedModel[param].push(false)
        }
      } else {
        this.selected[param].forEach((row) => {
          this.$delete(this.form[param], row)
        })
        for (let i = 0; i < this.form[param].length; i++) {
          this.selectedModel[param].push(false)
        }
      }
      this.selected[param] = []
      this.selectedModel[param] = []
      this.indeterminate[param] = false
      this.allSelected[param] = false
    },
    clearDelete() {
      this.filterAddressSelected = []
      this.selectAllAddress = false
    },
    categoryAction(item) {
      if (item.text == this.$t('global.create') + ' ' + this.$t('master.form.customer.industryCat')) this.$bvModal.show('modal-add-category')
      this.form.category = item
    },
    addCategory(param, obj) {
      this.instantCreate[param].push(obj)
    },
    paymentAction(item) {
      if (item.name == this.$t('global.create') + ' ' + this.$t('master.form.customer.top.title')) this.$bvModal.show('modal-add-payment')
      this.form.paymentTerms = item
    },
    addPayment() {
      this.$bvModal.show('modal-payment')
    },
    openModalDelete() {
      for (let i = 0; i < this.filterAddressSelected.length; i++) {
        this.$apollo
          .query({
            query: GET_DETAIL_ADDRESS,
            variables: {
              filter: {
                geofenceId: parseInt(this.filterAddressSelected[i]),
              },
            },
          })
          .then((res) => {
            var isSuccessful = res.data.geofence.isSuccessful
            if (isSuccessful) {
              this.deleteAddress.push(res.data.geofence.geofence)
            }
          })
      }
      this.$bvModal.show('modal-delete')
    },
    toDeleteAddress(bvModalEvent) {
      bvModalEvent.preventDefault()
      let promises = []
      for (let i = 0; i < this.filterAddressSelected.length; i++) {
        promises.push(
          this.$apollo.mutate({
            mutation: DELETE_ADDRESS,
            variables: {
              input: {
                geofenceId: this.filterAddressSelected[i],
              },
            },
          })
        )
      }
      Promise.all(promises).then(() => {
        this.$apollo.queries.geofences.refetch()
        this.$toast.success(`Data berhasil dihapus`)
        this.clearDelete('address')
        this.$bvModal.hide('modal-delete')
      })
    },
    resetModal() {
      this.deleteAddress = []
      this.instantCreate.category = []
      this.form.category = null
    },
    onRowAddressClicked(item) {
      this.$router.push({
        name: 'Master Customer Address Update',
        params: { id: item.geofenceId },
      })
    },
    onContactClick(data, i) {
      data.type = 'form'
      this.form.contact[i].type = 'form'
    },
    onNoteClick(data, i) {
      data.type = 'form'
      this.form.deliveryNote[i].type = 'form'
    },
    checkEmpty() {
      var isEmpty = true
      var forms = this.form
      var excepts = ['taxNo']
      Object.keys(this.form).forEach(function (key) {
        if (forms[key] != null && forms[key] != '') {
          if (typeof forms[key] !== 'object') {
            if (!excepts.includes(key)) {
              isEmpty = false
            }
          } else {
            if (!excepts.includes(key)) {
              Object.keys(forms[key]).forEach(function (subKey) {
                if (forms[key][subKey] != null && forms[key][subKey] != '') {
                  isEmpty = false
                }
              })
            }
          }
        }
      })
      return isEmpty
    },
    checkChanged() {
      var isChanged = false
      var forms = this.form
      var formOld = this.formOld
      Object.keys(this.form).forEach(function (key) {
        if (forms[key] != formOld[key]) {
          if (key == 'sales' && forms[key] != null) {
            if (forms[key].name != formOld[key].name) {
              isChanged = true
            }
          } else if (key == 'category' && forms[key] != null) {
            if (forms[key].text != formOld[key].text) {
              isChanged = true
            }
          } else if (key == 'paymentTerms' && forms[key] != null) {
            if (forms[key].name != formOld[key].name) {
              isChanged = true
            }
          } else {
            isChanged = true
          }
        }
      })
      return isChanged
    },
    toCancel() {
      var isEmpty = this.checkEmpty()
      if (this.$route.params.id) {
        isEmpty = !this.checkChanged()
      }
      if (isEmpty) {
        this.$router.push('/master/customer')
      } else {
        Swal.fire({
          title: 'Batalkan',
          text: 'Anda yakin akan membatalkan',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#f46a6a',
          cancelButtonColor: '#34c38f',
          confirmButtonText: 'Ya',
          cancelButtonText: 'Tidak',
        }).then((result) => {
          if (result.value) {
            this.$router.push('/master/customer')
          }
        })
      }
    },
    handleOk() {
      this.handleSubmit()
    },
    handleSubmit() {
      if (this.$v.$invalid) {
        this.$v.$touch()
        return
      }
    },
  },
}
</script>
<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" :items="items" class="mc-page-three" />
      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <div class="float-end">
          <b-button @click="toCancel" variant="outline-primary" class="mx-2">
            <i class="mc-fa icon-fill_close"></i> {{ $t('global.cancel') }}
          </b-button>
          <b-button variant="primary" type="button" @click="handleOk()">
            <i class="mc-fa icon-outline_save"></i> {{ this.$t('global.save') }}
          </b-button>
        </div>
      </div>
    </div>
    <form ref="form" @submit.stop.prevent="handleSubmit" class="mc-form">
      <!-- Informasi Perusahaan -->
      <h4 class="card-title">{{ $t('master.form.customer.customerInfo') }}</h4>
      <b-card>
        <b-row>
          <b-col sm="12" md="3" class="mb-3">
            <b-form-group
              id="customerNameLabel"
              :label="$t('master.form.customer.customer')"
              label-for="customerName"
              label-class="required"
            >
              <b-form-input
                id="customerName"
                :placeholder="$t('master.form.customer.customer')"
                v-model="form.customerName"
                :class="{
                  'is-invalid': $v.form.customerName.$error,
                }"
              ></b-form-input>
              <div v-if="$v.form.customerName.$error" class="invalid-feedback">
                <span v-if="!$v.form.customerName.required">
                  {{ $t('master.form.customer.customer') }}
                  {{ $t('global.validation.required') }}
                </span>
              </div>
            </b-form-group>
          </b-col>
          <b-col sm="12" md="3" class="mb-3">
            <b-form-group id="emailLabel" label="Email" label-for="email" label-class="required">
              <b-form-input
                id="email"
                placeholder="Email"
                v-model="form.email"
                trim
                :class="{
                  'is-invalid': $v.form.email.$error,
                }"
              ></b-form-input>
              <div v-if="$v.form.email.$error" class="invalid-feedback">
                <span v-if="!$v.form.email.required"> {{ $t('master.form.customer.emailRequired') }} </span>
                <span v-if="!$v.form.email.email"> {{ $t('emailFormat') }} </span>
              </div>
            </b-form-group>
          </b-col>
          <b-col sm="12" md="3" class="mb-3">
            <b-form-group
              id="salesLabel"
              :label="$t('master.form.customer.marketingEmp')"
              label-for="sales"
              label-class="required"
            >
              <multiselect
                v-model="form.sales"
                :options="sales.sales"
                track-by="name"
                label="name"
                :placeholder="$t('master.form.customer.marketingEmp')"
                :class="{
                  'is-invalid': $v.form.sales.$error,
                }"
              ></multiselect>
              <div v-if="$v.form.sales.$error" class="invalid-feedback">
                <span v-if="!$v.form.sales.required"> {{ $t('master.form.customer.employeeRequired') }} </span>
              </div>
            </b-form-group>
          </b-col>
          <b-col sm="12" md="3" class="mb-3">
            <b-form-group id="taxNoLabel" label="NPWP" label-for="taxNo">
              <b-form-input
                id="taxNo"
                v-model="form.taxNo"
                placeholder="NPWP"
                @keypress="isNumber($event)"
              >
              </b-form-input>
            </b-form-group>
          </b-col>
          <b-col sm="12" md="3" class="mb-3">
            <b-form-group
              id="industry_category"
              :label="$t('master.form.customer.industryCat')"
              label-for="industry_category"
              label-class="required"
            >
              <multiselect
                v-model="form.category"
                :placeholder="$t('master.form.customer.industryCat')"
                :options="companyCategories.companyCategories"
                label="text"
                @select="categoryAction"
                :class="{
                  'is-invalid': $v.form.category.$error,
                }"
              ></multiselect>
              <div v-if="$v.form.category.$error" class="invalid-feedback">
                <span v-if="!$v.form.category.required">
                  {{ $t('master.form.customer.industryCategoryRequired') }}
                </span>
              </div>
            </b-form-group>
          </b-col>
          <b-col sm="12" md="3" class="mb-3">
            <b-form-group id="paymentTerms" :label="$t('master.form.customer.top.title')" label-for="paymentTerms">
              <multiselect
                v-model="form.paymentTerms"
                :placeholder="$t('master.form.customer.top.title')"
                :options="payment.payment"
                label="name"
                @select="paymentAction"
              ></multiselect>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card>

      <!-- Informasi Perusahaan -->
      <div class="clearfix mb-3">
        <div class="float-start">
          <h4 class="card-title">{{ $t('master.form.address.addressList') }}</h4>
        </div>

        <div class="float-end">
          <b-button
            v-if="filterAddressSelected.length"
            variant="outline-danger"
            class="mx-2"
            @click="openModalDelete"
          >
            <i class="mc-fa icon-outline_trash"></i> {{ $t('global.delete') }}
          </b-button>
          <b-button variant="primary" @click="$router.push({ name: 'Master Customer Address' })">
            <i class="mc-fa icon-outline_plus"></i> {{ $t('global.addField') }}
          </b-button>
        </div>
      </div>
      <b-card>
        <div class="row">
          <div class="col-sm-4 col-md-4 mc-row-check-wrapper">
            <h6 v-if="filterAddressSelected.length > 0" class="mc-row-check">
              <span class="badge btn-success">{{ filterAddressSelected.length }}</span>
              {{ $t('master.address.form.selectedRow') }}
              <a class="color-primary" @click="clearDelete('address')">{{
                $t('master.address.form.clearAll')
              }}</a>
            </h6>
          </div>
          <div class="col-sm-8 col-md-8 d-flex flex-row-reverse mc-table-view-wrapper">
            <div class="mc-table-view">
              <p class="mc-label">{{ $t('global.shown') }}</p>
              <multiselect
                v-model="show_model"
                :options="show"
                :multiple="true"
                :placeholder="$t('global.object.allColumn')"
                track-by="label"
                label="label"
              >
                <template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
              </multiselect>
              <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                <label class="d-inline-flex align-items-center mc-table-view__search">
                  <i class="mc-fa fas fa-search"></i>
                  <b-form-input
                    v-model="filter"
                    type="search"
                    :placeholder="$t('global.search') + '...'"
                    class="ms-2"
                    @input="searchData"
                  ></b-form-input>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="table-responsive my-3 border border-1">
          <b-table
            small
            show-empty
            :fields="visibleAddress"
            :items="geofences.data"
            class="datatables"
            responsive="lg"
            empty-table
            :empty-text="$t('global.emptyTable')"
            :empty-filtered-text="$t('global.emptyFilteredTable')"
            @filtered="onFiltered"
            :busy="$apollo.queries.geofences.loading"
          >
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
              </div>
            </template>
            <template #head(check)>
              <div class="form-check">
                <input
                  class="form-check-input me-1"
                  type="checkbox"
                  value="all"
                  v-model="selectAllAddress"
                  @input="toggleAllAddress"
                />
              </div>
            </template>
            <template #cell(check)="data">
              <div class="form-check">
                <input
                  class="form-check-input me-1"
                  type="checkbox"
                  :value="data.item.geofenceId"
                  v-model="filterAddressSelected"
                  @input="checkAddress"
                />
              </div>
            </template>
            <template #cell(fenceName)="data">
              <a href="javascript:void(0)" @click="onRowAddressClicked(data.item)">
                <strong class="text-primary">
                  {{ data.item.fenceName }}
                </strong>
              </a>
            </template>
          </b-table>
        </div>
        <div class="row">
          <div class="col-sm-12 col-md-6">
            <div id="tickets-table_length" class="dataTables_length">
              <label class="d-inline-flex align-items-center">
                {{ $t('global.show') }}
                <b-form-select
                  class="form-select form-select-sm"
                  v-model="perPage"
                  size="sm"
                  :options="pageOptions"
                  @input="changePerPage"
                >
                </b-form-select>
                {{ $t('global.entry') }}
                <p>
                  {{ $t('global.shown') }} &nbsp;<strong>{{
                    totalRows > 0 ? (currentPage - 1) * perPage + 1 : 0
                  }}</strong
                  >&nbsp;{{ $t('global.until') }}&nbsp;<strong>{{
                    Math.min(totalRows, currentPage * perPage)
                  }}</strong
                  >&nbsp;{{ $t('global.from') }}&nbsp;<strong>{{ totalRows }}</strong
                  >&nbsp;{{ $t('global.entry') }}
                </p>
              </label>
            </div>
          </div>
          <div class="col-sm-12 col-md-6">
            <div class="dataTables_paginate paging_simple_numbers float-end">
              <ul class="pagination pagination-rounded mb-0">
                <!-- pagination -->
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows == null ? rows : totalRows"
                  :per-page="perPage"
                  @change="changePage"
                ></b-pagination>
              </ul>
            </div>
          </div>
        </div>
      </b-card>

      <div class="clearfix mb-3">
        <div class="float-start">
          <h4 class="card-title">{{ $t('master.form.address.contactInfo') }}</h4>
        </div>

        <div class="float-end">
          <b-button
            v-if="selected.contact.length"
            @click="toDelete('contact')"
            variant="outline-danger"
            class="mx-2"
          >
            <i class="mc-fa icon-outline_trash"></i> {{ $t('global.delete') }}
          </b-button>
          <b-button variant="primary" @click="add('contact', { type: 'form' })">
            <i class="mc-fa icon-outline_plus"></i> {{ $t('global.addField') }}
          </b-button>
        </div>
      </div>

      <b-card>
        <div class="table-responsive my-3 border border-1">
          <b-table
            small
            show-empty
            :empty-text="$t('global.emptyTable')"
            :empty-filtered-text="$t('global.emptyFilteredTable')"
            :fields="listContact"
            :items="form.contact"
            row-clicked="onContactClick"
            responsive="sm"
            class="datatables mc-table-fleetdoc"
          >
            <template #head(check)>
              <div class="form-check">
                <b-form-checkbox
                  @change="toggleAll($event, 'contact')"
                  v-model="allSelected.contact"
                  :indeterminate="indeterminate.contact"
                  :value="true"
                  :unchecked-value="false"
                >
                </b-form-checkbox>
              </div>
            </template>

            <template #cell(check)="data">
              <div class="form-check">
                <b-form-checkbox
                  @change="checkTable($event, data, 'contact')"
                  v-model="selectedModel.contact[data.index]"
                  :value="true"
                  :unchecked-value="false"
                >
                </b-form-checkbox>
              </div>
            </template>

            <template #cell(contactName)="data">
              <b-form-input
                v-if="data.item.type == 'form'"
                :placeholder="`${$t('global.form.enter')} Nama`"
                v-model="form.contact[data.index].contactName"
                :class="{
                  'is-invalid': $v.form.contact.$each[data.index].contactName.$error,
                }"
              ></b-form-input>
              <div
                v-if="$v.form.contact.$each[data.index].contactName.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.form.contact.$each[data.index].contactName.required">
                  Nama Kontak Wajib Terisi
                </span>
              </div>
              <!-- <span v-else>
                {{ data.item.contactName }}
              </span> -->
            </template>

            <template #cell(phoneNo)="data">
              <b-form-input
                v-if="data.item.type == 'form'"
                :placeholder="`${$t('global.form.enter')} Nomor Telepon`"
                v-model="form.contact[data.index].phoneNo"
                @keypress="isDecimal"
                @paste="isPastePhoneNumber"
                maxlength="15"
              ></b-form-input>
              <!-- <span v-else>
                {{ data.item.phoneNo }}
              </span> -->
            </template>

            <template #cell(position)="data">
              <b-form-input
                v-if="data.item.type == 'form'"
                :placeholder="`${$t('global.form.enter')} Posisi`"
                v-model="form.contact[data.index].position"
              ></b-form-input>
              <!-- <span v-else>
                {{ data.item.position }}
              </span> -->
            </template>

            <template #cell(email)="data">
              <b-form-input
                v-if="data.item.type == 'form'"
                :placeholder="`${$t('global.form.enter')} Email`"
                v-model="form.contact[data.index].email"
              ></b-form-input>
              <!-- <span v-else>
                {{ data.item.email }}
              </span> -->
            </template>
          </b-table>
        </div>
      </b-card>

      <div class="clearfix mb-3">
        <div class="float-start">
          <h4 class="card-title">{{ $t('master.form.customer.deliveryNotes') }}</h4>
        </div>

        <div class="float-end">
          <b-button
            v-if="selected.deliveryNote.length"
            @click="toDelete('deliveryNote')"
            variant="outline-danger"
            class="mx-2"
          >
            <i class="mc-fa icon-outline_trash"></i> {{ $t('global.delete') }}
          </b-button>
          <b-button variant="primary" @click="add('deliveryNote', { type: 'form' })">
            <i class="mc-fa icon-outline_plus"></i> {{ $t('global.addField') }}
          </b-button>
        </div>
      </div>

      <b-card>
        <div class="table-responsive my-3 border border-1">
          <b-table
            small
            show-empty
            :empty-text="$t('global.emptyTable')"
            :empty-filtered-text="$t('global.emptyFilteredTable')"
            :fields="listNote"
            :items="form.deliveryNote"
            row-clicked="onNoteClick"
            responsive="sm"
            class="datatables mc-table-fleetdoc"
          >
            <template #head(check)>
              <div class="form-check">
                <b-form-checkbox
                  @change="toggleAll($event, 'deliveryNote')"
                  v-model="allSelected.deliveryNote"
                  :indeterminate="indeterminate.deliveryNote"
                  :value="true"
                  :unchecked-value="false"
                >
                </b-form-checkbox>
              </div>
            </template>

            <template #cell(check)="data">
              <div class="form-check">
                <b-form-checkbox
                  @change="checkTable($event, data, 'deliveryNote')"
                  v-model="selectedModel.deliveryNote[data.index]"
                  :value="true"
                  :unchecked-value="false"
                >
                </b-form-checkbox>
              </div>
            </template>

            <template #cell(text)="data">
              <b-form-input
                v-if="data.item.type == 'form'"
                v-model="form.deliveryNote[data.index].text"
                trim
                :class="{
                  'is-invalid': $v.form.deliveryNote.$each[data.index].text.$error,
                }"
                placeholder="Catatan Pengiriman"
              ></b-form-input>
              <div
                v-if="$v.form.deliveryNote.$each[data.index].text.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.form.deliveryNote.$each[data.index].text.required">
                  {{ $t('contactNameRequired') }}
                </span>
              </div>
              <!-- <span v-else>
                {{ data.item.text }}
              </span> -->
            </template>
          </b-table>
        </div>
      </b-card>
    </form>
    <!-- Modal for Delete Confirmation -->
    <b-modal
      class="mc-modal"
      id="modal-delete"
      title="Hapus"
      size="md"
      centered
      scrollable
      @hidden="resetModal"
    >
      <div class="card-body mc-modal__filter p-2">
        <p>{{ $t('DeleteValidation') }}</p>
        <b-list-group>
          <b-list-group-item v-for="address in deleteAddress" :key="address.geofenceId">{{
            address.fenceName
          }}</b-list-group-item>
        </b-list-group>
      </div>
      <template #modal-footer="{ cancel }">
        <b-row class="mc-modal__filter-footer mx-0">
          <b-col sm="12" md="12" class="mc-modal__filter-footer-btn">
            <b-button variant="outline-primary" @click="cancel()" class="me-2">
              {{ $t('global.cancel') }}
            </b-button>
            <b-button @click="toDeleteAddress" variant="primary"> {{ $t('global.yes') }} </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>
    <b-modal
      class="mc-modal"
      id="modal-add-category"
      :title="`${$t('global.action.create')} ${$t('master.form.customer.industryCat')}`"
      size="lg"
      centered
      scrollable
      @hidden="resetModal"
    >
      <div class="clearfix mb-3">
        <div class="float-end">
          <b-button
            v-if="selected.category.length"
            @click="toDelete('category')"
            variant="outline-danger"
            class="mx-2"
          >
            <i class="mc-fa icon-outline_trash"></i> {{ $t('global.delete') }}
          </b-button>
          <b-button variant="primary" @click="addCategory('category', { type: 'form' })">
            <i class="mc-fa icon-outline_plus"></i> {{ $t('global.addField') }}
          </b-button>
        </div>
      </div>
      <b-card>
        <div class="table-responsive my-3 border border-1">
          <b-table
            small
            show-empty
            :empty-text="$t('global.emptyTable')"
            :empty-filtered-text="$t('global.emptyFilteredTable')"
            :fields="listCategory"
            :items="instantCreate.category"
            responsive="sm"
            class="datatables mc-table-fleetdoc"
          >
            <template #head(check)>
              <div class="form-check">
                <b-form-checkbox
                  @change="toggleAll($event, 'category')"
                  v-model="allSelected.category"
                  :indeterminate="indeterminate.category"
                  :value="true"
                  :unchecked-value="false"
                >
                </b-form-checkbox>
              </div>
            </template>

            <template #cell(check)="data">
              <div class="form-check">
                <b-form-checkbox
                  @change="checkTable($event, data, 'category')"
                  v-model="selectedModel.category[data.index]"
                  :value="true"
                  :unchecked-value="false"
                >
                </b-form-checkbox>
              </div>
            </template>

            <template #cell(text)="data">
              <b-form-input
                v-if="data.item.type == 'form'"
                v-model="instantCreate.category[data.index].text"
                trim
                :placeholder="$t('master.form.customer.industryCat')"
              ></b-form-input>
              <span v-else>
                {{ data.item.text }}
              </span>
            </template>
          </b-table>
        </div>
      </b-card>
      <template #modal-footer="{ cancel }">
        <b-row class="mc-modal__filter-footer mx-0">
          <b-col sm="12" md="12" class="mc-modal__filter-footer-btn">
            <b-button variant="outline-primary" @click="cancel()" class="me-2">
              {{ $t('global.cancel') }}
            </b-button>
            <b-button variant="primary"> {{ $t('global.save') }} </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>
    <b-modal
      class="mc-modal"
      id="modal-add-payment"
      :title="`${$t('global.action.create')} ${$t('master.form.customer.top.title')}`"
      size="lg"
      centered
      scrollable
      @hidden="resetModal"
    >
      <form class="mc-form">
        <b-row>
          <b-col md="6">
            <div class="mb-3 form-group">
              <label class="required">{{ $t('master.form.customer.top.payerName') }}</label>
              <b-form-input
                v-model="instantCreate.paymentTerms.name"
                :placeholder="`${$t('global.form.enter')} ${$t('master.form.customer.top.payerName')}`"
              ></b-form-input>
            </div>
          </b-col>
          <b-col md="6">
            <div class="mb-3 form-group">
              <label class="required">{{ $t('master.form.customer.top.timeLimit') }}</label>
              <b-form-input
                v-model="instantCreate.paymentTerms.paymentDue"
                :placeholder="`${$t('global.form.enter')} ${$t('master.form.customer.top.timeLimit')}`"
                type="number"
                @keypress="isNumber"
                @paste="isPasteNumber"
              ></b-form-input>
            </div>
          </b-col>
          <b-col md="12">
            <div class="mb-3 form-group">
              <label>{{ $t('master.form.customer.top.description') }}</label>
              <b-form-input
                v-model="instantCreate.paymentTerms.desc"
                :placeholder="`${$t('global.form.enter')} ${$t('master.form.customer.top.description')}`"
              ></b-form-input>
            </div>
          </b-col>
        </b-row>
      </form>
      <template #modal-footer="{ cancel }">
        <b-row class="mc-modal__filter-footer mx-0">
          <b-col sm="12" md="12" class="mc-modal__filter-footer-btn">
            <b-button variant="outline-primary" @click="cancel()" class="me-2">
              {{ $t('global.cancel') }}
            </b-button>
            <b-button variant="primary"> {{ $t('global.yes') }} </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>
  </Layout>
</template>
